<template>
  <section class="container mb-s"> 
    <h2 class="mb-s section-title">我的保單</h2>
    <div class="user-order-count mb-m">
      <UserOrderCountCard
        v-for="key in Object.keys(orderInfo.countOfOrderType)"
        :key="key"
        :type="key"
        :count="orderInfo.countOfOrderType[key]"
      />
    </div>
    <h2 class="mb-s section-title">我的服務人員</h2>
    <div class="user-card padding-m shadow-wrapper" v-if="profile.refAgent">
    <h3>
      {{ profile.refAgent }}
      </h3>
    </div>
    <h2 class="mb-s section-title">最新諮詢紀錄</h2>
    <div v-if="advisorys.length < 0">
      <div 
        class="img-wrapper" 
        :style="{width: '200px', height: '200px', margin: '0 auto'}" 
      >
        <img src="@/assets/empty-advisory.png">
      </div>
      <h3 class="text-center tips">目前沒有諮詢紀錄喔</h3>
    </div>
    <UserAdviCard
      v-for="(advi, i) in advisorys"
      :key="i"
      v-bind="{advi}"
    />  
  </section>
</template>

<script>
  import { mapState } from 'vuex';  
  import UserOrderCountCard from '@/components/cards/UserOrderCountCard';
  import UserAdviCard from '@/components/cards/UserAdviCard';

  export default {
    components: { UserOrderCountCard, UserAdviCard },
    computed: {
      ...mapState({
        profile: ({ user }) => ({ 
          ...user.profile                          
        }),
      })
    },
    inheritAttrs: false,
    props: {
      orderInfo: {
        type: Object,
        default: null
      },
      profile: {
        type: Object,
        default: null
      },
      advisorys: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        // tableCols
      };
    }
  };
</script>